export default {"src":"/_next/static/media/im3.eaf7ac1d.svg","height":196,"width":1388,"blurWidth":0,"blurHeight":0};